import { render } from "./NotificationBar.vue?vue&type=template&id=e769c992"
import script from "./NotificationBar.vue?vue&type=script&lang=ts"
export * from "./NotificationBar.vue?vue&type=script&lang=ts"
script.render = render

export default script